import {PatientEncounter} from '../../models/patient-encounter';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '../../../../shared/state/store';
import {useEffect, useState} from 'react';
import {
  DocumentsAccordionContentsV2,
  PatientDocument,
} from './documents-accordion-contents-v2';
import {getPatientDocuments} from '../../../state/patient-thunk';
import {
  getClient
} from '../../../../implementation-specialist/state/clients/implementation-clients-thunk';
import CustomizeableAccordion
  from '../../../../shared/components/customizeable-accordion';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import {showErrorStatus} from '../../../../security/state/user-slice';

interface EncounterDocumentsAccordionProps {
  encounter: PatientEncounter;
}
export function EncounterDocumentsAccordion({
                                              encounter,
                                            }: EncounterDocumentsAccordionProps) {

  const dispatch = useDispatch<AppDispatch>();

  const [patientDocuments, setPatientDocuments] = useState<PatientDocument[] | null>(null);

  useEffect(() => {

    (async () => {

      try{
        const [docs] = await Promise.all([
          dispatch(
              getPatientDocuments({
                encounterId: encounter.patientEncounterId,
                fetchSmsEligibility: false,
              }),
          ).unwrap(),
          dispatch(getClient(encounter.clientId)).unwrap(),
        ]);
        setPatientDocuments(docs);
      }catch(e){
        dispatch(showErrorStatus("Error retrieving document and/or client"))
        setPatientDocuments(null);
      }

    })();

  }, [dispatch, encounter.patientEncounterId, encounter.clientId]);


  return (
          <CustomizeableAccordion
              icon={<InsertDriveFileIcon className="gray-icon" />}
              details={
                <div className="w-100">
                  <DocumentsAccordionContentsV2
                      documents={patientDocuments ?? []}
                      patientId={encounter.patientId}
                      patientEncounterId={encounter.patientEncounterId}
                  />
                </div>
              }
              hasScroll
              headerText="Documents"
              expandCallback={() => {}}
          />
  )
}